var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "education-form" }, [
    _vm.objectInstance
      ? _c("div", { staticClass: "service-from fieldset-form" }, [
          _c("div", { staticClass: "row gx-1" }, [
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "service-from__form-group form-group fieldset-form__form-group",
                  class: { "form-group--invalid": _vm.errors.name },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.objectInstance.name,
                        expression: "objectInstance.name",
                      },
                    ],
                    staticClass:
                      "form-group__input form-control service-from__form-control fieldset-form__form-control",
                    attrs: { placeholder: "Место учебы", type: "text" },
                    domProps: { value: _vm.objectInstance.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.objectInstance,
                          "name",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.name
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "form-group__error-message invalid-feedback",
                        },
                        [_vm._v(_vm._s(_vm.errors.name.join(", ")))]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "service-from__form-group form-group fieldset-form__form-group",
                  class: { "form-group--invalid": _vm.errors.position },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.objectInstance.position,
                        expression: "objectInstance.position",
                      },
                    ],
                    staticClass:
                      "form-group__input form-control service-from__form-control fieldset-form__form-control",
                    attrs: { placeholder: "Специальность", type: "text" },
                    domProps: { value: _vm.objectInstance.position },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.objectInstance,
                          "position",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.position
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "form-group__error-message invalid-feedback",
                        },
                        [_vm._v(_vm._s(_vm.errors.position.join(", ")))]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "service-from__actions fieldset-form__actions" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn--inverse-primary service-from__save",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.saveForm()
                    },
                  },
                },
                [_vm._v("Сохранить")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--outline-variant service-from__cancel",
                  attrs: { type: "button" },
                  on: { click: _vm.closeForm },
                },
                [_vm._v("Отмена")]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }